import TextField from "@mui/material/TextField";
import CLogo from "../../assets/icons/logo.svg";
import axios from "axios";
import OtpInput from "react-otp-input";
import { setLoginMode } from "../../redux/slices/modalSlice";
import { setAuthCookies } from "./../../services/cookies";
import { setCredentials } from "../../redux/slices/authSlice";
import { fetchMyData } from "../../redux/slices/myDataSlice";
import { setOnboarding } from "../../redux/slices/authSlice";
import { useGoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import googleLogo from "../../assets/channel_images/google_logo.svg";
import { domainUrl } from "./../../utils/globals";
import { getCsrfToken } from "../../services/csrfToken";
import GoogleOneTapLogin from "./GoogleAuth";
import { useSelector } from "react-redux";
import {
  React,
  useState,
  useEffect,
  useRef,
  useNavigate,
  useDispatch,
  useLocation,
  hostUrl,
} from "../../globals/imports";

const AuthPage = ({ isSubdomain }) => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const myData = useSelector((state) => state.myData);
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isOtp, setIsOtp] = useState(false);
  const location = useLocation();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [forgotEmail, setForgotEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [otpBackend, setOtpBackend] = useState("");
  const [otp, setOtp] = useState("");
  const [newError, setNewError] = useState("");
  const [forgotError, setForgotError] = useState("");
  const dispatch = useDispatch();
  const [forgot, setForgot] = useState(false);
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [redirectDomain, setRedirectDomain] = useState("");
  const csrfToken = getCsrfToken();

  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const [errors, setErrors] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    forgotEmail: "",
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const redirectParam = searchParams.get("redirect");
    const redirectParamDomain = searchParams.get("redirectDomain");
    if (redirectParam) {
      setRedirectUrl(redirectParam);
    }
    if (redirectParamDomain) {
      setRedirectDomain(redirectParamDomain);
    }
  }, [location.search]);

  useEffect(() => {
    if (!isLoggedIn) return;
    const searchParams = new URLSearchParams(location.search);
    const redirectParam = searchParams.get("redirect") || "";
    const redirectParamDomain = searchParams.get("redirectDomain") || "";
    if (redirectParamDomain && redirectParam) {
      window.location.replace(
        `https://${redirectParamDomain}.${domainUrl}${redirectParam}`
      );
    } else if (redirectParamDomain) {
      window.location.replace(`https://${redirectParamDomain}.${domainUrl}`);
    } else if (redirectParam) {
      navigate(redirectParam, { replace: true });
    } else {
      navigate(`/admin/dashboard`, { replace: true });
    }
  }, [isLoggedIn, myData?.username, location.search, navigate]);

  const handleOnboardOpen = () => {
    dispatch(setOnboarding(true));
    if (redirectDomain !== "" && redirectUrl !== "") {
      navigate(`/channels/onboarding?redirectDomain=${redirectDomain}& `, {
        replace: true,
      });
    } else if (redirectDomain !== "") {
      navigate(`/channels/onboarding?redirectDomain=${redirectDomain}`, {
        replace: true,
      });
    } else if (redirectUrl !== "") {
      navigate(`/channels/onboarding?redirect=${redirectUrl}`, {
        replace: true,
      });
    } else {
      navigate(`/channels/onboarding`, {
        replace: true,
      });
    }
  };

  const clearData = () => {
    setFullName("");
    setEmail("");
    setPassword("");
    setIsLogin(false);
    setIsOtp(false);
    setOtp("");
    setOtpBackend("");
    setNewError("");
  };

  const handleToggleLogin = () => {
    setNewError("");
    setIsLogin(!isLogin);
    setErrors({
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
      agree: "",
    });
  };
  const handleToggleOtp = () => {
    setNewError("");
    setIsOtp(false);
    setErrors({
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
      agree: "",
    });
  };
  const handleToggleForgot = () => {
    setNewError("");
    setIsLogin(false);
    setForgot(false);
    setErrors({
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
      forgotPassword: "",
      agree: "",
    });
  };
  const handleResendCode = async () => {
    setNewError("");
    try {
      const userData = {
        name: fullName.trim(),
        email: email.trim(),
      };
      await axios
        .post(`${hostUrl}/api/register`, userData, {
          headers: {
            "X-CSRF-Token": csrfToken,
          },
          withCredentials: true,
        })
        .then((response) => {
          if (response.data.success === true) {
            setOtpBackend(response.data.otp);
            setIsOtp(true);
          } else {
            setNewError(response.data.message);
          }
        });
    } catch (error) {
      console.error("Error registering", error);
    }
  };

  const handleforgotPassword = async () => {
    setForgotError("");
    if (!forgotEmail) {
      setForgotError("Please Enter email!");
    } else {
      try {
        const response = await axios.post(
          `${hostUrl}/api/forgot/password`,
          {
            email: forgotEmail.trim(),
          },
          {
            headers: {
              "X-CSRF-Token": csrfToken,
            },
            withCredentials: true,
          }
        );
        setForgotError(response.data.message);
      } catch (error) {
        setForgotError("Error in validation. Please try again.");
      }
    }
  };
  const fetchUserDetails = async (accessToken) => {
    try {
      const response = await axios.get(
        "https://www.googleapis.com/oauth2/v2/userinfo",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      setNewError("Auth failed. Please try again");
    }
  };
  const registerOrLoginUserGoogle = async (userData) => {
    try {
      return await axios.post(
        `${hostUrl}/api/google/auth`,
        {
          name: userData.name,
          email: userData.email,
          website: website.trim(),
        },
        {
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Failed to register/login user", error);
      throw new Error("Failed to register/login");
    }
  };

  const handleGoogleSuccess = async (tokenResponse) => {
    try {
      const userData = await fetchUserDetails(tokenResponse.access_token);
      const response = await registerOrLoginUserGoogle(userData);
      if (response.data.success) {
        dispatch(
          setCredentials({
            user: response.data.user,
            token: response.data.token,
          })
        );
        setAuthCookies(response.data.token, response.data.user);
        clearData();
        fetchMyData();
        if (response.data.islogin === false) {
          handleOnboardOpen();
        } else {
          if (redirectDomain !== "" && redirectUrl !== "") {
            window.location.replace(
              `https://${redirectDomain}.${domainUrl}${redirectUrl}`
            );
          } else if (redirectDomain !== "") {
            window.location.replace(`https://${redirectDomain}.${domainUrl}`);
          } else if (redirectUrl !== "") {
            navigate(`${redirectUrl}`, {
              replace: true,
            });
          } else {
            navigate(`/admin/dashboard`, {
              replace: true,
            });
          }
        }
      }
    } catch (error) {
      console.error("Error during login process:", error);
      setNewError("Error Registering. Please try again");
    }
  };
  const handleTapGoogleSuccess = async (tokenResponse) => {
    try {
      const userData = JSON.parse(atob(tokenResponse.credential.split(".")[1]));
      const response = await registerOrLoginUserGoogle(userData);
      window.google?.accounts.id.cancel();
      if (response.data.success) {
        dispatch(
          setCredentials({
            user: response.data.user,
            token: response.data.token,
          })
        );
        setAuthCookies(response.data.token, response.data.user);
        clearData();
        fetchMyData();

        if (response.data.islogin === false) {
          handleOnboardOpen();
        } else {
          if (redirectDomain !== "" && redirectUrl !== "") {
            window.location.replace(
              `https://${redirectDomain}.${domainUrl}${redirectUrl}`
            );
          } else if (redirectDomain !== "") {
            window.location.replace(`https://${redirectDomain}.${domainUrl}`);
          } else if (redirectUrl !== "") {
            navigate(`${redirectUrl}`, {
              replace: true,
            });
          } else {
            navigate(`/admin/dashboard`, {
              replace: true,
            });
          }
        }
      }
    } catch (error) {
      console.error("Error during login process:", error);
      setNewError("Error Registering. Please try again");
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: () => {
      setNewError("Validation failed. Please try again.");
      console.log("Login failed");
    },
  });

  const oneTapGoogleLogin = useGoogleOneTapLogin({
    onSuccess: handleTapGoogleSuccess,
    onError: () => {
      console.log("One Tap Login Failed");
    },
    prompt_parent_id: "one-tap-container", // Ensures placement
  });

  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const validateForm = () => {
    setNewError("");
    let valid = true;
    const newErrors = {
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
    };

    if (!fullName && !isLogin) {
      newErrors.fullName = "Full name is required";
      valid = false;
    }
    if (!email) {
      newErrors.email = "Email is required";
      valid = false;
    }
    if (!password) {
      newErrors.password = "Password is required";
      valid = false;
    }
    if (!isLogin && !agreed) {
      newErrors.agree = "You must agree to the terms and privacy policy";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };
  const validateForm2 = () => {
    let valid = true;
    if (!fullName && !isLogin) {
      valid = false;
    }
    if (!email) {
      valid = false;
    }
    if (!password) {
      valid = false;
    }

    if (!isLogin && !agreed) {
      valid = false;
    }
    return valid;
  };

  useEffect(() => {
    setButtonEnabled(validateForm2());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullName, email, password, agreed, isLogin]);

  useEffect(() => {
    const handleAutofill = () => {
      const emailField = emailRef.current;
      const passwordField = passwordRef.current;

      if (emailField && passwordField) {
        setEmail(emailField.value);
        setPassword(passwordField.value);
        setButtonEnabled(validateForm2());
      }
    };

    handleAutofill();

    window.addEventListener("focus", handleAutofill);

    return () => {
      window.removeEventListener("focus", handleAutofill);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, password]);

  const handleChangeOtp = async (value) => {
    setOtp(value);
    if (value.length === 6 && value === otpBackend) {
      setNewError("");
      const userData = {
        name: fullName.trim(),
        email: email.trim(),
        password: password,
        website: website.trim(),
      };
      try {
        await axios
          .post(`${hostUrl}/api/verify/auth`, userData, {
            headers: {
              "X-CSRF-Token": csrfToken,
            },
            withCredentials: true,
          })
          .then((response) => {
            if (response.data.success) {
              // console.log(response.data);
              setAuthCookies(response.data.token, response.data.user);
              dispatch(
                setCredentials({
                  user: response.data.user,
                  token: response.data.token,
                })
              );
              clearData();
              handleOnboardOpen();
            } else {
              setNewError(response.data.message);
            }
          });
      } catch (error) {
        setNewError("Error Registering. Please try again");
      }
    } else if (otp.length === 6) {
      setNewError("Enter Correct Otp");
      console.log("some error");
    }
  };

  const handleFormSubmit = async () => {
    setNewError("");
    setLoading(true);
    if (validateForm()) {
      if (isLogin) {
        const userData = {
          email: email.trim(),
          password: password,
        };
        try {
          await axios
            .post(`${hostUrl}/api/login`, userData, {
              withCredentials: true,
            })
            .then((response) => {
              if (response.data.success === true) {
                dispatch(
                  setCredentials({
                    user: response.data.user,
                    token: response.data.token,
                  })
                );
                setAuthCookies(response.data.token, response.data.user);
                clearData();
                fetchMyData();
                if (redirectDomain !== "" && redirectUrl !== "") {
                  window.location.replace(
                    `https://${redirectDomain}.${domainUrl}${redirectUrl}`
                  );
                } else if (redirectDomain !== "") {
                  window.location.replace(
                    `https://${redirectDomain}.${domainUrl}`
                  );
                } else if (redirectUrl !== "") {
                  navigate(`${redirectUrl}`, {
                    replace: true,
                  });
                } else {
                  navigate(`/user/${response.data.user.username}/profile`, {
                    replace: true,
                  });
                }
              } else {
                setNewError(response.data.message);
              }
              dispatch(setLoginMode(false));
              setLoading(false);
            });
        } catch (error) {
          console.log("Error registering", error);
          setNewError("Error in logging in. Please try again.");
          setLoading(false);
        }
      } else {
        const userData = {
          name: fullName.trim(),
          email: email.trim(),
        };
        try {
          await axios
            .post(`${hostUrl}/api/register`, userData, {
              headers: {
                "X-CSRF-Token": csrfToken,
              },
              withCredentials: true,
            })
            .then((response) => {
              if (response.data.success === true) {
                setOtpBackend(response.data.otp);
                setIsOtp(true);
              } else {
                setNewError(response.data.message);
              }
              setLoading(false);
            });
        } catch (error) {
          console.error("Error registering", error);
          setLoading(false);
        }
      }
    }
  };

  return (
    <div
      className="flex min-h-screen w-full flex-col items-center justify-center px-4 py-10"
      style={{
        background:
          "radial-gradient(70% 70% at 82% 8%, rgba(242,97,27,.20) 0%, rgba(242,97,27,0) 58%), radial-gradient(60% 90% at 18% 100%, rgba(242,97,27,.16) 0%, rgba(242,97,27,0) 60%), #141414",
      }}
    >
      <GoogleOneTapLogin handleTapGoogleSuccess={handleTapGoogleSuccess} />
      <img
        src={CLogo}
        alt="logo"
        className="mb-6 h-8 cursor-pointer"
        onClick={() => navigate("/")}
      />
      <div className="w-full max-w-md flex flex-col items-center rounded-2xl border border-theme-chatDivider bg-theme-secondaryBackground px-6 py-9 sm:px-10">
        <h3 className=" text-2xl sm:text-3xl w-full text-center font-medium tracking-wider text-theme-secondaryText font-inter">
          {forgot
            ? "Forgot Password"
            : isLogin
            ? "Get back to your channel"
            : isOtp
            ? "Verify it's you"
            : "Signup to get started"}
        </h3>
        <p className="text-theme-placeholder text-sm mt-1">
          {forgot
            ? "Enter your email and we'll send you a reset link."
            : isLogin
            ? "Sign in to manage your community."
            : isOtp
            ? "Enter the code we just sent you."
            : "Create your account to get started."}
        </p>
        {forgot ? (
          <div className="mt-4 w-full">
            <p className="text-theme-secondaryText font-normal text-xs font-inter">
              Enter the email address associated with your account and we'll
              send you a link to reset your password.
            </p>
            <div className="mt-6 w-full">
              <TextField
                label="email address"
                error={Boolean(errors.forgotEmail)}
                type="email"
                helperText={errors.forgotEmail}
                variant="outlined"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
                fullWidth
                InputProps={{
                  style: {
                    color: "var(--theme-primarysecondaryText)",
                    padding: "0px 3px",
                    fontWeight: "400",
                  },
                  inputProps: {
                    style: {
                      color: "var(--theme-primaryText)",
                      fontSize: "14px",
                    },
                    placeholder: "email address",
                  },
                }}
                InputLabelProps={{
                  style: { color: "var(--theme-subtitle)" },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "var(--theme-chatDivider)",
                    },
                    "&:hover fieldset": {
                      borderColor: "var(--theme-chatDivider)",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "var(--theme-chatDivider)",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "var(--theme-placeholder)",
                    opacity: 1,
                  },
                  "& .MuiInputBase-root": {
                    maxHeight: "45px",
                    lineHeight: "45px",
                  },
                }}
              />
            </div>
            <div className="justify-center text-center align-center mb-8">
              <button
                onClick={handleforgotPassword}
                className={`w-full py-2.5 mt-6 rounded-xl ${
                  forgotEmail !== ""
                    ? "text-theme-primaryBackground bg-theme-secondaryText"
                    : "text-theme-buttonDisableText  bg-theme-buttonDisable "
                }  font-normal text-sm`}
              >
                Continue
              </button>
              <p className="text-theme-error font-normal mt-4 text-xs font-inter">
                {forgotError}
              </p>
            </div>
            <p className="text-center text-theme-secondaryText text-xs mt-8 mb-4">
              Don't have an account?
              <button
                onClick={handleToggleForgot}
                className="text-secondaryText underline ml-1 "
              >
                Register
              </button>
            </p>
          </div>
        ) : isOtp ? (
          <div className="mt-8">
            <p className="text-theme-secondaryText font-normal text-sm font-inter">
              Enter the verification code we just sent to your email id {email}
            </p>
            <div className="mt-5">
              <OtpInput
                value={otp}
                onChange={handleChangeOtp}
                numInputs={6}
                renderSeparator={<span className="w-2"></span>}
                renderInput={(props) => (
                  <input
                    {...props}
                    style={{
                      width: "34px",
                      height: "40px",
                      borderRadius: "6px",
                      backgroundColor: "#2B2930",
                      textAlign: "center",
                      color: "white",
                    }}
                    inputMode="numeric" // Ensures only numeric input
                    pattern="[0-9]*" // Restricts input to digits
                  />
                )}
              />
              <p className="w-full  text-theme-primaryText text-xs mt-3 font-inter">
                Didn't received code?
                <button
                  onClick={handleResendCode}
                  className="text-theme-secondaryText underline ml-1 font-base font-inter font-normal"
                >
                  Resend
                </button>
              </p>
              <p className="w-full  text-theme-primaryText text-xs mb-12 mt-10 font-inter">
                Entered wrong email?
                <button
                  onClick={handleToggleOtp}
                  className="text-theme-secondaryText underline ml-1 font-base font-inter font-normal"
                >
                  Change
                </button>
              </p>
            </div>
          </div>
        ) : (
          <>
            {!isLogin && (
              <div className="mt-4 w-full">
                <TextField
                  label="full name"
                  variant="outlined"
                  error={Boolean(errors.fullName)}
                  helperText={errors.fullName}
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  fullWidth
                  InputProps={{
                    style: {
                      color: "var(--theme-primaryText)",
                      padding: "0px 3px",
                      fontWeight: "400",
                    },
                    inputProps: {
                      style: {
                        color: "var(--theme-primaryText)",
                        fontSize: "14px",
                      },
                      placeholder: "email address",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "var(--theme-subtitle)" },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "var(--theme-chatDivider)",
                      },
                      "&:hover fieldset": {
                        borderColor: "var(--theme-chatDivider)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "var(--theme-chatDivider)",
                      },
                      "&.Mui-focused .MuiInputLabel-root": {
                        color: "#D0BCFF !important",
                      },
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "var(--theme-placeholder)",
                      opacity: 1,
                    },
                    "& .MuiInputBase-root": {
                      maxHeight: "45px",
                      lineHeight: "45px",
                    },
                  }}
                />
              </div>
            )}
            <div className="mt-4 w-full">
              <TextField
                label="email address"
                error={Boolean(errors.email)}
                type="email"
                inputRef={emailRef}
                helperText={errors.email}
                onChange={(e) => setEmail(e.target.value)}
                variant="outlined"
                value={email}
                fullWidth
                InputProps={{
                  style: {
                    color: "var(--theme-primaryText)",
                    padding: "0px 3px",
                    fontWeight: "400",
                  },
                  inputProps: {
                    style: {
                      color: "var(--theme-primaryText)",
                      fontSize: "14px",
                    },
                    placeholder: "email address",
                  },
                }}
                InputLabelProps={{
                  style: { color: "var(--theme-subtitle)" },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "var(--theme-chatDivider)",
                    },
                    "&:hover fieldset": {
                      borderColor: "var(--theme-chatDivider)",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "var(--theme-chatDivider)",
                    },
                    "&.Mui-focused .MuiInputLabel-root": {
                      color: "#D0BCFF !important",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "var(--theme-placeholder)",
                    opacity: 1,
                  },
                  "& .MuiInputBase-root": {
                    maxHeight: "45px",
                    lineHeight: "45px",
                  },
                }}
              />
            </div>
            <div className="mt-4 w-full">
              <TextField
                label={isLogin ? "password" : "create password"}
                variant="outlined"
                type={showPassword ? "text" : "password"}
                error={Boolean(errors.password)}
                helperText={errors.password}
                inputRef={passwordRef}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleFormSubmit();
                  }
                }}
                fullWidth
                InputProps={{
                  style: {
                    color: "var(--theme-primaryText)",
                    padding: "0px 3px",
                    fontWeight: "400",
                  },
                  inputProps: {
                    style: {
                      color: "var(--theme-primaryText)",
                      fontSize: "14px",
                    },
                    placeholder: "password",
                  },

                  endAdornment: (
                    <InputAdornment position="end" className="mr-2">
                      <IconButton
                        className="mr-2 "
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOff sx={{ color: "#c4c4c4" }} />
                        ) : (
                          <Visibility sx={{ color: "#c4c4c4" }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  style: { color: "var(--theme-subtitle)" },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "var(--theme-chatDivider)",
                    },
                    "&:hover fieldset": {
                      borderColor: "var(--theme-chatDivider)",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "var(--theme-chatDivider)",
                    },
                    "&.Mui-focused .MuiInputLabel-root": {
                      color: "#D0BCFF !important",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "var(--theme-placeholder)",
                    opacity: 1,
                  },
                  "& .MuiInputBase-root": {
                    maxHeight: "45px",
                    lineHeight: "45px",
                  },
                }}
              />
            </div>

            {isLogin && (
              <button
                onClick={() => setForgot(true)}
                className="text-theme-primaryText w-full mt-2  text-end text-xs mb-2"
              >
                forgot password?
              </button>
            )}
            {!isLogin && (
              <div className="flex items-center mt-4">
                <input
                  type="checkbox"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  className="w-4 h-4 text-black bg rounded-sm checked:bg-theme-primary focus:ring-primary checked:ring-primary"
                />
                <label className="ml-2 text-xs text-theme-primaryText ">
                  I agree to the{" "}
                  <span className="text-theme-buttonEnable underline bg-transparent">
                    terms
                  </span>{" "}
                  &{" "}
                  <span
                    href="#"
                    className="text-theme-buttonEnable underline bg-transparent"
                  >
                    privacy policy
                  </span>
                </label>
              </div>
            )}
            <button
              onClick={handleFormSubmit}
              className={` w-full py-2.5 mt-6 rounded-xl ${
                buttonEnabled
                  ? "text-theme-primaryBackground bg-theme-secondaryText"
                  : "text-theme-buttonDisableText  bg-theme-buttonDisable"
              }  font-normal text-sm`}
            >
              {isLogin ? "Login" : "Register"}
            </button>
            <div className="justify-center items-center w-full my-4">
              {newError !== "" ? (
                <p className="text-center text-theme-error  text-xs">
                  {newError}
                </p>
              ) : (
                !isSubdomain && (
                  <p className="text-center text-theme-secondaryText">or</p>
                )
              )}
            </div>
            {!isSubdomain && (
              <button
                onClick={() => googleLogin()}
                className="w-full px-1.5 py-2 mb-4 text-xs  font-normal items-center
               text-theme-secondaryText bg-theme-tertiaryBackground rounded-xl border border-theme-chatDivider"
              >
                <img
                  src={googleLogo}
                  alt="Google logo"
                  className="inline w-6 h-6 mr-2"
                />
                {isLogin ? "Sign in with Google" : "Sign up with Google"}
              </button>
            )}
            <p className="text-center text-theme-secondaryText text-xs mb-10 mt-2">
              {isLogin
                ? "Don't have an account? "
                : "Already have an account? "}
              <button
                onClick={handleToggleLogin}
                className="text-theme-secondaryText underline ml-2"
              >
                {loading ? "Please wait..." : isLogin ? "Register" : "Login"}
              </button>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthPage;
